import { z } from 'zod';

import { startPayloadSchema } from '../constants';
import { connectorLabelSchema, externalIdSchema, jsonObjectSchema } from './common';

/**
 * POST {project.resolveUrl}
 *
 * Обмен одноразового кода из deep-link на личность. Человек нажал «Поддержка»
 * в продукте, попал в `t.me/<support_bot>?start=<code>`, мы поймали /start и
 * спрашиваем проект: чей это код.
 *
 * Зачем, если telegram_id и так глобален: во-первых, провенанс — код говорит,
 * с какого экрана пришёл человек; во-вторых, страховка на случай, когда
 * telegram_id в проекте ещё не записан.
 */

export const resolveRequestSchema = z.object({
  /** Тот самый payload из /start. Ограничения алфавита — Telegram, не наши. */
  code: startPayloadSchema,
});
export type ResolveRequest = z.infer<typeof resolveRequestSchema>;

/**
 * Discriminated union по found: found=true без external_id бессмысленно —
 * ровно за ним мы и ходили. Результат пишется в Contact.externalId с
 * bindSource=DEEPLINK и больше не перепроверяется.
 */
export const resolveResponseSchema = z.discriminatedUnion('found', [
  z.object({
    found: z.literal(true),
    external_id: externalIdSchema,
    name: connectorLabelSchema.optional(),
    /** Произвольные данные провенанса: экран, кампания, тариф. Ложится в StartCode.meta. */
    meta: jsonObjectSchema.default({}),
  }),
  z.object({
    found: z.literal(false),
    reason: connectorLabelSchema.optional(),
  }),
]);
export type ResolveResponse = z.infer<typeof resolveResponseSchema>;
export type ResolveResponseInput = z.input<typeof resolveResponseSchema>;
export type ResolveResponseFound = Extract<ResolveResponse, { found: true }>;
